import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CmsService } from 'src/app/core/cms/service.service';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SERVICE_END_POINT, UtilService, QuoteDataCaptureService, AnalyticsService } from 'src/app/shared';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-post-registration',
  templateUrl: './post-registration.component.html',
  styleUrls: ['./post-registration.component.scss']
})
export class PostRegistrationComponent implements OnInit, OnDestroy {
  contentData: any ;
  CMSDataRegisterFailure;
  CMSDataRegisterSuccess;
  protected registrationResponse: any;
  public errorType: string;
  registartionData = [];
  private subscripBeforeLogin: Subscription;
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private cmsService: CmsService,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilService,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private analyticsService: AnalyticsService) {

    this.contentData = this.route.snapshot.data.contentData.postRegistration;
    this.registrationResponse = this.activatedRoute.snapshot.data.contentData.postRegistration.registerResponse;
  }
  ngOnInit() {
    this.subscripBeforeLogin = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.utilService.afterSaveSuccesfully()

    });
    this.activatedRoute.paramMap.subscribe(param => {
    this.errorType = param.get('type');
    //console.log(this.errorType);
  });
    if (this.errorType && (this.errorType === 'Failure' || this.errorType === 'Unavailable')) {
      this.GetCMSDataServiceFailure();
    } else {
      this.GetCMSDataServiceActivation();
    }
  }
  backToRegistration() {
    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: 'Back',
      pageID: this.utilService.getScreenNameFromURL(this.router.url)
    });
    this.router.navigate(['/home/registration']);
  }
  GetCMSDataServiceFailure() {
    //console.log('original value = ');
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_RegistrationUnavailable;
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSDataRegisterFailure = res;
      if (this.CMSDataRegisterFailure) {
      /** In the line below we are over-writing the contentData object values with CMSDataRegisterFailure object values */
        this.contentData.failureHeader = this.CMSDataRegisterFailure.string_SystemUnavailable;
        this.contentData.additionalInfo = this.CMSDataRegisterFailure.string_RegisterAnotherTime;
        this.contentData.contactUs = this.CMSDataRegisterFailure.stringGroup_RegisterHO;
        //console.log('changed value = ');
        }
    });
  }

  GetCMSDataServiceActivation() {
    //console.log('original value = ');
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_ActivationLinkAcknowledgement;
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSDataRegisterSuccess = res;
      if (this.CMSDataRegisterSuccess) {
      /** In the line below we are over-writing the contentData object values with CMSDataRegisterSuccess object values */
        this.contentData.successHeader = this.CMSDataRegisterSuccess.string_ActivationLinkAcknowledgementTitle;
        this.contentData.emailData = this.CMSDataRegisterSuccess.html_ActivateYourAccount1 + ' ' + this.CMSDataRegisterSuccess.commonBlock.string_CsPhoneNo
        + ' ' + this.CMSDataRegisterSuccess.html_ActivateYourAccount2;
        //console.log('changed value = ');
        }
    });
  }

  logIn(){
    this.utilService.loginDetails();
  }
  
  /** End of code block for CMS */

  ngOnDestroy() {
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
  }
  }
